/**
 * Calculate dynamic y-axis maximum based on chart data
 * Returns Math.max(100, maxValue * 1.3) rounded up to nearest 50 multiple
 */
export function calculateDynamicYMax(chartData) {
    if (!chartData || !chartData.datasets || chartData.datasets.length === 0) {
        return 100;
    }
    let maxValue = 0;
    chartData.datasets.forEach((dataset) => {
        if (dataset.data && Array.isArray(dataset.data)) {
            dataset.data.forEach((value) => {
                if (typeof value === "number" && value > maxValue) {
                    maxValue = value;
                }
            });
        }
    });
    const roundedMax = Math.ceil(maxValue / 50) * 50;
    return Math.max(100, roundedMax);
}
/**
 * Creates base chart configuration
 */
export function createBaseChartConfig(options = {}) {
    const { orientation = "vertical", showLegend = true, legendPosition = "bottom", maxTicksLimit, chartData = null, } = options;
    const isHorizontal = orientation === "horizontal";
    const dynamicMax = calculateDynamicYMax(chartData);
    const mainAxisConfig = {
        beginAtZero: true,
        max: dynamicMax,
    };
    const counterAxisConfig = maxTicksLimit ? { ticks: { maxTicksLimit } } : {};
    return {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: showLegend,
                position: legendPosition,
            },
        },
        indexAxis: isHorizontal ? "y" : "x",
        scales: {
            x: Object.assign({ grid: { display: false } }, (isHorizontal ? mainAxisConfig : counterAxisConfig)),
            y: Object.assign({ grid: { display: false } }, (isHorizontal ? counterAxisConfig : mainAxisConfig)),
        },
    };
}
/**
 * Creates responsive chart options that adapt to screen size
 */
export function createResponsiveChartConfig(baseConfig, isSmallScreen) {
    var _a;
    return Object.assign(Object.assign({}, baseConfig), { plugins: Object.assign(Object.assign({}, baseConfig.plugins), { legend: Object.assign(Object.assign({}, (_a = baseConfig.plugins) === null || _a === void 0 ? void 0 : _a.legend), { labels: {
                    boxWidth: isSmallScreen ? 12 : 20,
                    padding: isSmallScreen ? 8 : 10,
                    font: {
                        size: isSmallScreen ? 10 : 12,
                    },
                } }) }) });
}
/**
 * Calculate responsive chart height based on window height
 */
export function calculateChartHeight(windowHeight) {
    const reservedSpace = Math.min(300, windowHeight * 0.4);
    const availableHeight = windowHeight - reservedSpace;
    const minHeight = windowHeight < 600 ? 250 : 300;
    const maxHeight = windowHeight < 800 ? 400 : 600;
    const calculatedHeight = Math.max(minHeight, Math.min(maxHeight, availableHeight));
    return Math.max(calculatedHeight, 250);
}
